export default __webpack_public_path__ + "static/media/website_img.0f05bf9a.jpg";